export default class Address {
  id = 0;

  city = '';

  state = '';
}
